import { z } from 'zod'

/**
 * A `*.myshopify.com` domain. This is the canonical shop identifier everywhere in the
 * codebase, never the custom storefront domain, which merchants can change.
 */
export const shopDomainSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/, 'must be a myshopify.com domain')
  .brand<'ShopDomain'>()

export type ShopDomain = z.infer<typeof shopDomainSchema>

export function parseShopDomain(value: unknown): ShopDomain {
  return shopDomainSchema.parse(value)
}
